import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import React from "react";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import Odc from "../../Odc";
import { HandlingTimesFormProps } from "./HandlingTimesFormProps";
import { TIME_PLACEHOLDER_HOURS_MINUTES } from "../../../Forms/Constants/TimeConstants";
import { RhfHandlingTimeTextField } from "./RhfHandlingTimeTextField";

export const DefaultHandlingTimesForm = ({ disabledFields }: HandlingTimesFormProps) => {
  const { control } = useFormContext<Odc>();

  return (
    <Grid item xs={12}>
      <BorderedFormGrid>
        <Grid item xs={3}>
          <RhfHandlingTimeTextField
            name="DefaultInboundHandlingTime"
            control={control}
            placeholder={TIME_PLACEHOLDER_HOURS_MINUTES}
            label="Inbound Handling Time"
            disabledFields={disabledFields}
          />
        </Grid>
        <Grid item xs={3}>
          <RhfHandlingTimeTextField
            name="ReturnHandlingTime"
            control={control}
            placeholder={TIME_PLACEHOLDER_HOURS_MINUTES}
            label="Return Handling Time"
            disabledFields={disabledFields}
          />
        </Grid>
        <Grid item xs={6} />
      </BorderedFormGrid>
    </Grid>
  );
};
